import styled from 'styled-components';
import { prefix } from '../../../tools/settings';
var Header = styled.header.withConfig({
  displayName: "Headerstyles__Header",
  componentId: "sc-bhzrqp-0"
})(["background:var(--dentsu-color-white);box-shadow:var(--dentsu-shadow-8);width:100%;z-index:1;.", "-progress-bar{min-width:1024px;}"], prefix);
var HeaderInner = styled.div.withConfig({
  displayName: "Headerstyles__HeaderInner",
  componentId: "sc-bhzrqp-1"
})(["flex:1;display:flex;align-items:center;padding:var(--dentsu-spacing-24) var(--dentsu-spacing-32);min-width:1024px;"]);
var StepCounter = styled.div.withConfig({
  displayName: "Headerstyles__StepCounter",
  componentId: "sc-bhzrqp-2"
})(["color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-60);font-weight:var(--dentsu-font-weight-light);letter-spacing:var(--dentsu-tracking-tighter);line-height:1;margin-right:var(--dentsu-spacing-32);span{padding:0 10px;}"]);
var StepHeading = styled.div.withConfig({
  displayName: "Headerstyles__StepHeading",
  componentId: "sc-bhzrqp-3"
})(["flex:1;overflow:hidden;"]);
var StepMeta = styled.h1.withConfig({
  displayName: "Headerstyles__StepMeta",
  componentId: "sc-bhzrqp-4"
})(["color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);letter-spacing:var(--dentsu-tracking-normal);margin:var(--dentsu-spacing-2) 0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"]);
var StepTitle = styled.div.withConfig({
  displayName: "Headerstyles__StepTitle",
  componentId: "sc-bhzrqp-5"
})(["display:flex;align-items:center;h2{color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-28);font-weight:var(--dentsu-font-weight-light);letter-spacing:var(--dentsu-tracking-tight);margin:0 var(--dentsu-spacing-8) 0 0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}.", "-chip{margin-top:0;margin-bottom:0;}"], prefix);
var StepActions = styled.div.withConfig({
  displayName: "Headerstyles__StepActions",
  componentId: "sc-bhzrqp-6"
})(["button{margin-left:var(--dentsu-spacing-8);}"]);
export var Styled = {
  Header: Header,
  HeaderInner: HeaderInner,
  StepCounter: StepCounter,
  StepHeading: StepHeading,
  StepMeta: StepMeta,
  StepTitle: StepTitle,
  StepActions: StepActions
};